import { SET_SEARCH_KEY, SET_SPECIALITIES, SET_SEARCH_RESULT } from "../actions/template.action";

const INITIAL_STATE = {
   searchTemplate: "",
   specialities: [],
   searchResult: "",
};

export default function template(state = INITIAL_STATE, action) {
   switch (action.type) {
      case SET_SEARCH_KEY:
         return {
            ...state,
            searchTemplate: action.payload,
         };
      case SET_SPECIALITIES:
         return {
            ...state,
            specialities: action.payload,
         };
      case SET_SEARCH_RESULT:
         return {
            ...state,
            searchResult: action.payload,
         };
      default:
         return state;
   }
}
